import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import FuseNavItem from '../FuseNavItem';
import isUrlInChildren from '../isUrlInChildren';
import usePathname from '@fuse/hooks/usePathname';
import type { FuseNavigationProps } from '../FuseNavigation';
import type { FuseNavItemType } from '../types/FuseNavItemType';
import { AccordionProvider } from './AccordionContext';

const StyledList = styled(List)(({ theme: _theme }) => ({
	paddingTop: 0,
	paddingBottom: 0,
	'& .fuse-list-item-text': {
		margin: 0,
	},
	'& .fuse-list-item-text-primary': {
		lineHeight: '20px',
	},
	'&.active-square-list': {
		'& .fuse-list-item, & .active.fuse-list-item': {
			width: '100%',
			borderRadius: '0',
		},
	},
	'&.dense': {
		'& .fuse-list-item': {
			paddingTop: 0,
			paddingBottom: 0,
			height: 32,
		},
	},
}));

/**
 * FuseNavVerticalLayout1
 * This component is used to render vertical navigations using
 * the Material-UI List component. It accepts the FuseNavigationProps props
 * and renders the FuseNavItem components accordingly
 */
function FuseNavVerticalLayout1(props: FuseNavigationProps) {
	const { navigation, active, dense, className, onItemClick, checkPermission } = props;
	const pathname = usePathname();

	function handleItemClick(item: FuseNavItemType) {
		onItemClick?.(item);
	}

	const initialOpenId =
		navigation?.find((_item) => pathname && (_item.url === pathname || isUrlInChildren(_item, pathname)))?.id ?? null;

	return (
		<StyledList
			className={clsx('navigation whitespace-nowrap pl-3 py-0', `active-${active}-list`, dense && 'dense', className)}
		>
			<AccordionProvider initialOpenId={initialOpenId}>
				{navigation?.map((_item) => (
					<FuseNavItem
						key={_item.id}
						type={`vertical-${_item.type}`}
						item={_item}
						nestedLevel={0}
						onItemClick={handleItemClick}
						checkPermission={checkPermission}
					/>
				))}
			</AccordionProvider>
		</StyledList>
	);
}

export default FuseNavVerticalLayout1;
